import datatables from './datatables';
import error from './error';
import orders from './orders';
import reports from './reports';
import notify from './notify';
import downtimeSelector from './downtimeSelector';
import settings from './settings';

export default {
  datatables,
  error,
  orders,
  downtimeSelector,
  reports,
  notify,
  settings,

  //
  world: 'Мир',
  plant: 'Фабрика',
  area: 'Участок',
  areas: 'Участки',
  line: 'Линия',
  lines: 'Линии',
  delete: 'Удалить',
  segment: 'Сегмент',
  machine: 'Машина',
  machines: 'Машины',
  element: 'Элемент',
  map: 'Карта',
  issue: 'Проблема',
  typeOfIssue: 'Тип проблемы',
  currentShift: 'Текущая смена',
  noShift: 'Без смены',
  currentOrder: 'Текущий заказ',
  today: 'Сегодня',
  shift: 'Смена',
  shifts: 'Смены',
  noShifts: 'Смен не назначено',
  asset: {
    globalCounter: 'Глобальный счетчик', localCounter: 'Местный счетчик', waterCounter: 'Счетчик воды', valvePosition: 'Положение клапана', waterLevel: 'Уровень воды', waterFlow: 'Поток воды', pumpBalance: 'Баланс насоса',
  },
  wall: {
    comment: 'Комментарий', comments: 'Комментарии', vision: 'Зрение/ VIsion', downtimeEditorSettings: 'Настройки редактора времени простоя',
  },
  menu: {
    monitoring: 'Мониторинг', reports: 'Отчеты', overview: 'Обзор', andon: 'Доска "Андон"', weeklyAnalysis: 'Еженедельный анализ', scoreAnalysis: 'Анализ баллов', settings: 'Настройки', userSettings: 'Настройки аккаунта', notifications: 'Уведомления', language: 'Язык', user: 'Пользователь', setAsHome: 'Сделать домашней страницей', setFullScreen: 'Полноэкранный режим', logout: 'Выйти', loadMore: 'Загрузить больше', selectPlant: 'Выбрать завод', homePageDevice: { title: 'Домашняя страница для этого устройства', description: 'Этот экран будет отображаться всегда после входа в систему на этом устройстве.' }, homePageUser: { title: 'Домашняя страница вашей учетной записи', description: 'Этот экран будет отображаться после вашего входа в систему, если на устройстве нет домашней страницы.' },
  },
  import: {
    upload: 'Перетащите сюда файлы для загрузки', notSaved: 'Не сохранено', saved: 'Сохранено', actionRequired: 'Необходимо выполнить действие', checked: 'Проверено', fillAndAdd: 'Заполните и добавьте', chooseImage: 'Выберите изображение', nothingImported: 'Нет достоверных данных для импорта', previousImports: 'Предыдущий импорт', fileIsBeingProcessed: 'Файл обрабатывается. Мы отправим вам уведомление, когда оно будет сформировано', groupSuccessfullyAssign: 'Успешно добавлен в группу', groupFailedToAssign: 'Не удалось назначить группу', groupSuccessfullyRemoved: 'Успешно удален из группы', groupFailedToRemove: 'Не удалось удалить из группы',
  },
  work: {
    event: 'Проблема', events: 'Проблемы', state: 'Состояние', states: 'Состояния', systemStates: 'Состояние системы', reason: 'Причина', reasons: 'Причины', correctiveAction: 'Корректирующее действие', correctiveActions: 'Корректирующие действия', downtime: 'Время простоя', downtimes: 'Время простоя', wiki: 'Статьи из Wikipedia', disconnected: 'Отключен', rootCause: 'Корневая причина', detachRootCause: 'Устранить первопричину', rootMachine: 'Корневая причина для машины', spectrum: 'Спектр работы', downtimeList: 'Список простоев', default: 'По умолчанию', tags: 'Теги', addTags: 'Добавить теги', addSelected: 'Добавить выбранное', plannedDowntimes: 'Запланированные простои', unplannedDowntimes: 'Незапланированные простои', workTime: 'Рабочее время', actionTaken: 'Принятые корректирующие меры', noOngoingOrder: 'Нет текущего заказа',
  },
  general: {
    name: 'Имя',
    from: 'Из',
    search: 'Поиск',
    max: 'Максимум',
    min: 'Мин.',
    noResults: 'Нет результатов',
    title: 'Заголовок',
    description: 'Описание',
    fromStart: 'С начала',
    confirm: 'Подтвердить',
    tryAgain: 'Попробуйте еще раз',
    to: 'К',
    toEnd: 'В конец',
    finish: 'Заканчивать',
    add: 'Добавить',
    all: 'Все',
    clear: 'Очистить',
    hidden: 'Скрыть',
    remove: 'Удалить',
    detach: 'Отсоединить',
    attach: 'Прикреплять',
    close: 'Закрывать',
    cancel: 'Отмена',
    edit: 'Редактировать',
    event: 'Событие',
    details: 'Подробности',
    summary: 'Краткое содержание',
    save: 'Сохранить',
    change: 'Изменить',
    noData: 'Нет данных',
    nothingDefined: 'Ничего не определено',
    others: 'Другое',
    back: 'Назад',
    results: 'Результаты',
    selected: 'Выбрано',
    selectAll: 'Выбрать все',
    createNew: 'Создать новый',
    useExisting: 'Использовать существующие',
    select: 'Выбрать',
    saveSuccessed: 'Сохранение выполнено',
    saveFailed: 'Не удалось сохранить',
    shouldArchive: 'Следует архивировать',
    areYouSure: 'Вы уверены?',
    view: 'Просмотреть',
    yes: 'Да',
    no: 'Нет',
    reason: 'Причина',
    actions: 'Действия',
    reasonUnknown: 'Причина неизвестна',
    forcedByOperator: 'По решению оператора',
    type: 'Тип',
    valueType: 'Тип значения',
    value: 'Значение',
    unit: 'Единица измерения',
    disable: 'Отключить',
    disabled: 'Отключено',
    disabledShe: 'Отключено',
    inactive: 'Неактивный',
    enable: 'Активировать',
    enabled: 'Включено',
    enabledShe: 'Включено',
    ignore: 'Игнорировать',
    nominal: 'Номинальный',
    unsavedChanges: 'Есть несохран. изменения. Действительно хотите выйти?',
    now: 'Сейчас',
    showAll: 'Показать все',
    showMore: 'Показать больше',
    continue: 'Продолжать',
    group: 'Группа',
    download: 'Скачать',
    dir: {
      top: 'Верх', bottom: 'Низ', left: 'Лево', right: 'Право',
    },
    sourceURI: 'URI источника',
    dimensions: 'Габаритные размеры',
    status: 'Статус',
    code: 'Код',
    start: 'Начало',
    end: 'Конец',
    update: 'Обновлять',
    deviceId: 'Идентификатор устройства',
    time: 'Время',
    show: 'Показать',
    hide: 'Скрыть',
    last: 'Последний',
    deleted: 'Удалено'
  },
  machineControl: {
    turnOn: 'Включить', turnOff: 'Выключить', current: 'Текущий', liveStream: 'Прямая трансляция', disconnectedWarning: 'ПРЕДУПРЕЖДЕНИЕ! Машина в настоящее время без связи - выключение приведет к потере буферизованных данных',
  },
  lineControl: { startLine: 'Запусить линию <b>{line}</b>?', stop: 'Стоп', start: 'Старт' },
  time: {
    week: 'Неделя', minutes: 'Минуты', date: 'Дата', day: 'День', hour: 'час', hours: 'часы', hoursPlural: 'часы', days: 'дней', month: 'Месяц', year: 'Год', quarter: 'Квартал', resolution: 'разрешение', duration: 'Продолжительность', seconds: 'секунды', startDate: 'Дата начала', endDate: 'Дата окончания', startTime: 'Время начала', endTime: 'Время окончания', selectDay: 'Выберите день', longerThan: 'Дольше чем', shorterThan: 'Короче чем', scope: 'Временной диапазон', currentOrder: 'Текущий заказ', showMinorStops: 'Показать второстепенные остановки', plannedOnly: 'Показать только запланированные', unplannedOnly: 'Показать только незапланированные', excludeDefaults: 'Скрыть настройки по умолчанию', monday: 'Понедельник', tuesday: 'Вторник', wednesday: 'Среда', thursday: 'Четверг', friday: 'Пятница', saturday: 'Суббота', sunday: 'Воскресенье',
  },
  graph: {
    flow: 'Поток', flows: 'Потоки', production: 'Производственный поток', physical: 'Физический', supplying: 'Поставка', archiveChanges: 'Архивировать изменения', isActive: 'Активный', addElement: 'Добавить элемент', detached: 'Отдельно', andon: 'Андон',
  },
  monitoring: {
    ofThePlan: 'Вы достигли% {значение}% от этого значения',
    noPlan: 'Нет плана',
    averageTargetPerformance: 'Средняя целевая производительность',
    designSpeed: 'Проектная производительность',
    validatedSpeed: 'Подтвержденная производительность',
    targetProduction: 'Производственная цель',
    maxPerfProduction: 'План на основе результатов',
    plannedFromOrders: 'План на основе заказа',
    planned: 'Планируется',
    notInFlow: 'Не в производственном потоке',
    produced: 'Произведено',
    wasted: 'Потрачено',
    lastMessage: 'Последнее сообщение',
    noMessages: 'Нет сообщений',
    noAlarms: 'Нет сигналов',
    noConnectionInfo: 'Нет информации о подключении',
    noConnection: 'Нет связи с сервером',
    processing: 'Обработка',
    dataProcessingFromLast: 'Обработка данных с последнего',
    lineStates: 'Состояния линии',
    disconnected: 'отключен',
    serverDisconnected: 'Сервер отключен',
    working: 'работающий',
    ready: 'готов',
    notWorking: 'во время простоя',
    productionProgress: 'Прогресс производства',
    production: 'Производство',
    productionMap: 'Карта производства',
    workStates: 'Рабочие состояния',
    workLog: 'История работы',
    event: 'Мероприятие',
    events: 'События',
    cause: 'Причина',
    causes: 'Причины',
    reasons: 'Причины',
    warnings: 'Предупреждения',
    correctiveAction: 'Корректирующее действие',
    stopRealTime: 'Остановить реальное время',
    stoppedRealTime: 'Реальное время остановлено',
    realTime: 'Реальное время',
    toRealTime: 'К реальному времени',
    downtimes: 'Время простоя',
    changeCurrentDowntime: 'Изменить время простоя',
    doubleClickToEdit: 'Дважды щелкните, чтобы изменить время простоя',
    percentShare: 'Доля в процентах',
    timeShare: 'Соместная аренда имущества',
    minorStops: 'включая второстепенные остановки',
    remainingPlannedProduction: 'Возможная остаточная производительность при номинальной скорости',
    remainingEstimatedProduction: 'Возможная остаточная производительность на основе эффективной скорости',
    remainingTime: 'Оставшееся время',
    performance: { short: 'Производительность за последние 3 минуты', effective: 'Эффективная производительность', nominal: 'Номинальная производительность' },
    segment: {
      baseQuantity: 'Базовое количество', baseQuality: 'Базовое качество', baseAvailability: 'Базовая доступность', basePerformance: 'Базовая производительность',
    },
    machine: {
      counter: 'Счетчик', parameters: 'Параметры', alarms: 'Тревоги', processParameters: 'Параметры процесса', currentParameters: 'Текущие параметры', activeAlarms: 'Активные уведомления', counters: 'Счетчики', alarmsHoldups: 'Сигнализация и задержка', performanceInfo: 'Средняя производительность за последние 3 минуты', others: 'Другое', lifespan: 'Срок жизни', environmentCondition: 'Состояние среды', condition: 'Состояние актива', cost: 'Расходы', failurePreditcion: 'Прогнозирование поломки', probabilityFailure: 'Вероятность пломки в течение 10 дней', failureType: 'Тип отказа', timeToFailure: 'Прогнозируемое время до поломки', predictedFailure: 'Прогнозируемая поломка', maintenanceHistory: 'История ТО',
    },
    lineInfo: {
      advices: 'Подсказки', forService: 'Задания', jobs: 'Задачи', completed: 'Выполненные задачи', problems: 'Проблемы', planned: 'Задания в очереди', toAchieveTarget: 'Ожидаемый объем производства на данный момент:', confirmLinePause: 'Подтвердить паузу в работе линии',
    },
    worstAlarms: 'Худшие проблемы',
    problems: 'нет проблем | одна проблема | {0} проблемы',
  },
  components: {
    title: 'Компоненты', one: 'Компонент', usagePerUnit: 'Расход материалов на единицу продукции', required: 'Требуется', convertUnit: 'Конвертировать единицы', validation: 'Требуется проверка', batchTracking: 'Отслеживание серий', scanTrackingId: 'Отсканировать номер отслеживания', batchTrackingHelp: 'Когда отслеживание включено, вам необходимо указать \\n номер партии для каждой отсканированной упаковки.', defaultPackageQuantity: 'В упаковке', warningLevelPercentage: 'Процент предупреждений', warningLevel: 'Уровень предупреждения', warningLevelHelp: '\\n% - предупреждение при использовании некоторого процента упаковок\\n\\n min - предупреждение, когда приблизительное количество оставшихся минут\\n', scannerCode: 'Код сканера', scannerCodeType: 'тип кода', noTrackingId: 'Нет идентификатора отслеживания', scan: 'Сканировать', packages: 'Упаковки', scanPackages: 'Сканировать упаковки', noComponents: 'Нет назначенных компонентов', invalidCode: 'Компонент не найден', addComponent: 'Добавить компонент', closed: 'Закрыто', scanned: 'Отсканировано', closeConfirm: 'Закрыть', eta: 'Одобренное время привоза', active: 'Активный', clickToActivate: 'Нажмите, чтобы активировать', used: 'Потреблено', estimatedTotalQuantity: 'Ориентировочное необходимое количество', packageScannerCode: 'Код упаковок', defaultPackageQuantitySum: 'Общее количество в упаковках', registeredDate: 'Дата сканирования', trackingId: 'Идентификатор для отслеживания', consumptionType: { title: 'Тип потребления', help: "\\n 'MULTIPLE (множественный)' позволяется одновременно открывать несколько пакетов, первая из которых используется.\\n\\n 'SINGLE 9 (единичный)' автоматически закрывает предыдущий пакет, когда активируется новый, последний из них используется \\n" },
  },
  oee: {
    oee: 'OEE', oeeLoss: 'Потеря OEE', availability: 'Доступность', performance: 'Производительность', quality: 'Качество', teep: 'TEEP'
  },
  metrics: {
    mtbf: 'Средняя наработка на между поломками (MTBF)', mttr: 'Среднее время ремонта (MTTR)', mtbm: 'Среднее время безотказной работы между ТО (MTBM)', reliabilityMetrics: 'Метрики надежности',
  },
  energy: {
    usedEnergy: 'Энергии использовано', currentLeastEfficient: 'Наименее эффективная машина (текущ.)', currentPower: 'Текущая мощность', baseline: 'Исходный уровень', max: 'Средний макс',
  },
  score: {
    points: 'pt', reached: 'Достигнуто', target: 'Цель', failures: 'Поломки', sameWeek: 'То же положение, что и на прошлой неделе',
  },
  items: {
    items: 'Единицы', import: 'Импортировать единицы', itemGroups: 'Группы единиц', itemGroup: 'Группа единиц', groups: 'Группы', add: 'Добавьте единицу', addGroup: 'Добавить группу', new: 'Новый предмет', edit: 'Редактировать элемент', number: 'Число', description: 'Описание', quantity: 'Количество / поддон', unit: 'Количество единиц', performance: 'Показатели / производительность', expectedPerformance: 'Ожидаемая производительность', expectedChangeover: 'Ожидаемая производительность', packingStructure: 'Структура упаковки', groupPackingStructure: 'Структура групповой упаковки', itemRoutingSpeed: 'Скорость маршрутизации товара', groupRoutingSpeed: 'Скорость групповой маршрутизации', components: 'Компоненты',
  },
  pageNotFoundExplanation: 'Мы не можем найти эту страницу, \\n приносим извинения за неудобства',
  processParams: {
    compositionName: 'Название композиции', compositions: 'Композиции', saveComposition: 'Сохранить композицию', signals: 'Уведомления', signalName: 'Название сигнала', signalValue: 'Значение сигнала', ongoingState: 'Текущее состояние', ongoingProblem: 'Текущая проблема', ongoingOrder: 'Текущий заказ', problemStart: 'Начало проблемы', problemEnd: 'Конец проблемы', orderStart: 'Начало заказа', orderEnd: 'Конец заказа', orderProduction: 'Заказать изготовление',
  },
  healthcheck: { noDriverConnection: 'Нет подключения драйвера' },
  vision: {
    vision: 'Зрение\\ Vision', showAllClips: 'Показать все клипы', selectCamera: 'Выбрать камеру', getClip: 'Получить клип', getTheTwoPreviousMinutes: 'Получите 2 минуты до и 2 после начала простоя', noClips: 'Клипы не найдены', noRecords: 'У камеры нет записей с этого дня для скачивания', currentVideoTime: 'Текущее время видео', startVideoTime: 'Время начала видео', startDowntime: 'Время простоя', endDowntime: 'Конец простоя', showLiveVideo: 'Показать живое видео с камеры', selectStartClip: 'Начало видео', selectEndClip: 'Конец видео', videoDurationIs: 'Продолжительность видео составляет', invalidTimeRange: 'Неверный временной диапазон.', toMoreBefore: 'Выберите более раннюю дату начала для видео.', toMoreAfter: 'Выберите более позднюю дату окончания для видео.', maxVideoIs: 'Максимальная длина видео составляет', auto: 'А', autoLong: 'Видео запрашивается системой автоматически', manual: 'M', manualLong: 'Видео запрошено пользователем вручную', videoTrigger: 'При выборе тега VideoTrigger настраивается для этого типа проблемы',
    autoDownload: 'Запросить видео для всех будущих событий этого типа',
  },
  downloadStatus: {
    failed: 'Ошибка', inProgress: 'В ходе выполнения', success: 'Готово', failedOnEdge: 'Камера вышла из строя', noArchiveRecordings: 'У камеры нет записей', deleted: 'Удалено',
  },
  quests: 'Задачи',
  quest: {
    quest: 'Задача', questTitle: 'Заголовок задачи', questDescription: 'Описание задачи', project: 'Проект', type: 'Тип задачи', state: 'Состояние задачи', closeToState: 'Близко к состоянию', assignToGroups: 'Распределить по группам',
  },
  health: { health: 'Здоровье', healthHistory: 'История здоровья' },
  panel: {
    number: 'Число', sku: 'Sku', selectState: 'Выберите штат', selectMachine: 'Выбрать машину', comment: 'Комментарий', downtimeFrom: 'Простой с', ongoing: 'Простой в процессе', averagePerformance: 'Средняя производительность', currentPerformance: 'Текущие показатели\\производительность',
  },
  workCalendar: 'Рабочий календарь',
  schedule: 'График',
  importSchedule: 'График импорта',
  addSchedule: 'Добавить график',
  repeatEvery: 'Повторять каждые',
  repeatOn: 'Повторить в (день недели)',
  ends: 'Заканчивается',
  starts: 'Начинается',
  never: 'Никогда',
  on: 'в',
  calendar: 'Календарь',
  cycle: 'Цикл',
  deleteRecurringInstance: 'Удалить повторяющийся экземпляр',
  editRecurringInstance: 'Изменить повторяющийся экземпляр',
  thisInstance: 'Этот экземпляр',
  thisAndFollowingInstances: 'Этот и последующие примеры',
  allInstances: 'Все экземпляры',
  order: { addNewProperty: 'Добавить новую недвижимость' },
  noCycle: 'Цикл не определен',
  users: { firstName: 'Имя', lastName: 'Фамилия' },
  teams: { teamName: 'Название команды' },
  schedules: { addLine: 'Добавить строку в фильтры', clearLines: 'Очистить все строки' },
};
